import moment from 'moment';
export function formaterData(testdata) {
    let arr = [];
    for (let k = 0; k < 32; k++) {
        let obj = {
            c: k,
            r: 0,
            v: {
                ct: {
                    fa: 'General',
                    t: 'g',
                },
                v: '',
                m: '',
                tb: 2, //换行
                bl: 1,
            },
        };
        if (k === 0) {
            obj.v.v = 'NO.';
            obj.v.m = 'NO.';
            obj.v.ht = 0;
        }
        if (k === 1) {
            obj.v.v = 'id';
            obj.v.m = 'id';
        }
        if (k === 2) {
            obj.v.v = '项目名称';
            obj.v.m = '项目名称';
        }
        if (k === 3) {
            obj.v.v = '订单号';
            obj.v.m = '订单号';
        }
        if (k === 4) {
            obj.v.v = '全名';
            obj.v.m = '全名';
        }
        if (k === 5) {
            obj.v.v = '物料材质';
            obj.v.m = '物料材质';
        }
        if (k === 6) {
            obj.v.v = '原料长度';
            obj.v.m = '原料长度';
        }
        if (k === 7) {
            obj.v.v = '原料宽度';
            obj.v.m = '原料宽度';
        }
        if (k === 8) {
            obj.v.v = '原料高度';
            obj.v.m = '原料高度';
        }
        if (k === 9) {
            obj.v.v = '原料直径';
            obj.v.m = '原料直径';
        }
        if (k === 10) {
            obj.v.v = '图号';
            obj.v.m = '图号';
        }
        if (k === 11) {
            obj.v.v = '需求数量';
            obj.v.m = '需求数量';
        }
        if (k === 12) {
            obj.v.v = '单位';
            obj.v.m = '单位';
        }
        if (k === 13) {
            obj.v.v = '重量/面积';
            obj.v.m = '重量/面积';
        }
        if (k === 14) {
            obj.v.v = '单价';
            obj.v.m = '单价';
        }
        if (k === 15) {
            
            obj.v.v = '工件费';
            obj.v.m = '工件费';
        }
        if (k === 16) {
            obj.v.v = '金额';
            obj.v.m = '金额';
        }
        if (k === 17) {
            obj.v.v = '承接厂商';
            obj.v.m = '承接厂商';
        }
        if (k === 18) {
            obj.v.v = '所属';
            obj.v.m = '所属';
        }
        if (k === 19) {
            obj.v.v = '类别1';
            obj.v.m = '类别1';
        }
        if (k === 20) {
            obj.v.v = '类别2';
            obj.v.m = '类别2';
        }
        if (k === 21) {
            obj.v.v = '类别3';
            obj.v.m = '类别3';
        }
        if (k === 22) {
            obj.v.v = '产品类型';
            obj.v.m = '产品类型';
        }
        if (k === 23) {
            obj.v.v = '客户名称';
            obj.v.m = '客户名称';
        }
        if (k === 24) {
            obj.v.v = '产线';
            obj.v.m = '产线';
        }
        if (k === 25) {
            obj.v.v = '受单日期';
            obj.v.m = '受单日期';
        }
        if (k === 26) {
            obj.v.v = '要求到厂日期';
            obj.v.m = '要求到厂日期';
        }
        if (k === 27) {
            obj.v.v = '实际到厂日期';
            obj.v.m = '实际到厂日期';
        }
        if (k === 28) {
            obj.v.v = '延误天数';
            obj.v.m = '延误天数';
        }
        // if(k === 28){
        //     obj.v.v = '状态'
        //     obj.v.m = '状态'
        // }
        if (k === 29) {
            obj.v.v = '负责人';
            obj.v.m = '负责人';
        }
        if (k === 30) {
            obj.v.v = 'bomImportRecordId';
            obj.v.m = 'bomImportRecordId';
        }
        if(k === 31){
            obj.v.v = 'isUpdate';
            obj.v.m = 'isUpdate';
        }
        arr.push(obj);
    }
    for (let i = 0; i < testdata.length; i++) {
        for (let j = 0; j < 32; j++) {
            let obj = {
                c: j,
                r: i + 1,
                v: {
                    ct: {
                        fa: 'General',
                        t: 'g',
                    },
                    //若没有使用公式则不要吧f设为空
                    v: '',
                    m: '',
                    tb: 2, //换行
                },
            };
            if (j === 0) {
                obj.v.v = i + 1;
                obj.v.m = testdata[i].id;
                obj.v.ht = 0;
            }
            if (j === 1) {
                obj.v.v = testdata[i].id;
                obj.v.m = testdata[i].id;
            }
            if (j === 2) {
                obj.v.v = testdata[i].c项目名称;
                obj.v.m = testdata[i].c项目名称;
                // 这里判断是否有修改
                if ('oc项目名称' in testdata[i]) {
                    obj.v.ps = {
                        left: 0,
                        top: 0,
                        width: 10,
                        height: 20,
                        value: '修改前：' + (testdata[i].oc项目名称 === null ? '' : testdata[i].oc项目名称 + ''),
                        isshow: false,
                    };
                }
            }
            if (j === 3) {
                obj.v.v = testdata[i].c订单号;
                obj.v.m = testdata[i].c订单号;
                if ('oc订单号' in testdata[i]) {
                    obj.v.ps = {
                        left: 0,
                        top: 0,
                        width: 10,
                        height: 20,
                        value: '修改前：' + (testdata[i].oc订单号 === null ? '' : testdata[i].oc订单号 + ''),
                        isshow: false,
                    };
                }
            }
            if (j === 4) {
                obj.v.v = testdata[i].c全名;
                obj.v.m = testdata[i].c全名;
                if ('oc全名' in testdata[i]) {
                    obj.v.ps = {
                        left: 0,
                        top: 0,
                        width: 10,
                        height: 20,
                        value: '修改前：' + (testdata[i].oc全名 === null ? '' : testdata[i].oc全名 + ''),
                        isshow: false,
                    };
                }
            }
            if (j === 5) {
                obj.v.v = testdata[i].c物料材质;
                obj.v.m = testdata[i].c物料材质;
                if ('oc物料材质' in testdata[i]) {
                    obj.v.ps = {
                        left: 0,
                        top: 0,
                        width: 10,
                        height: 20,
                        value: '修改前：' + (testdata[i].oc物料材质 === null ? '' : testdata[i].oc物料材质 + ''),
                        isshow: false,
                    };
                }
            }
            if (j === 6) {
                obj.v.v = testdata[i].c原料长度;
                obj.v.m = testdata[i].c原料长度;
                // obj.v.ct.fa = '0.00'
                // obj.v.ct.t = 'n'
                if ('oc原料长度' in testdata[i]) {
                    obj.v.ps = {
                        left: 0,
                        top: 0,
                        width: 10,
                        height: 20,
                        value: '修改前：' + (testdata[i].oc原料长度 === null ? '' : testdata[i].oc原料长度 + ''),
                        isshow: false,
                    };
                }
            }
            if (j === 7) {
                obj.v.v = testdata[i].c原料宽度;
                obj.v.m = testdata[i].c原料宽度;
                // obj.v.ct.fa = '0.00'
                // obj.v.ct.t = 'n'
                if ('oc原料宽度' in testdata[i]) {
                    obj.v.ps = {
                        left: 0,
                        top: 0,
                        width: 10,
                        height: 20,
                        value: '修改前：' + (testdata[i].oc原料宽度 === null ? '' : testdata[i].oc原料宽度 + ''),
                        isshow: false,
                    };
                }
            }
            if (j === 8) {
                obj.v.v = testdata[i].c原料高度;
                obj.v.m = testdata[i].c原料高度;
                // obj.v.ct.fa = '0.00'
                // obj.v.ct.t = 'n'
                if ('oc原料高度' in testdata[i]) {
                    obj.v.ps = {
                        left: 0,
                        top: 0,
                        width: 10,
                        height: 20,
                        value: '修改前：' + (testdata[i].oc原料高度 === null ? '' : testdata[i].oc原料高度 + ''),
                        isshow: false,
                    };
                }
            }
            if (j === 9) {
                obj.v.v = testdata[i].c原料直径;
                obj.v.m = testdata[i].c原料直径;
                // obj.v.ct.fa = '0.00'
                // obj.v.ct.t = 'n'
                if ('oc原料直径' in testdata[i]) {
                    obj.v.ps = {
                        left: 0,
                        top: 0,
                        width: 10,
                        height: 20,
                        value: '修改前：' + (testdata[i].oc原料直径 === null ? '' : testdata[i].oc原料直径 + ''),
                        isshow: false,
                    };
                }
            }
            if (j === 10) {
                obj.v.v = testdata[i].c图号;
                obj.v.m = testdata[i].c图号;
                if ('oc图号' in testdata[i]) {
                    obj.v.ps = {
                        left: 0,
                        top: 0,
                        width: 10,
                        height: 20,
                        value: '修改前：' + (testdata[i].oc图号 === null ? '' : testdata[i].oc图号 + ''),
                        isshow: false,
                    };
                }
            }
            if (j === 11) {
                obj.v.v = testdata[i].c数量;
                obj.v.m = testdata[i].c数量;
                // obj.v.ct.fa = '0'
                // obj.v.ct.t = 'n'
                if ('oc数量' in testdata[i]) {
                    obj.v.ps = {
                        left: 0,
                        top: 0,
                        width: 10,
                        height: 20,
                        value: '修改前：' + (testdata[i].oc数量 === null ? '' : testdata[i].oc数量 + ''),
                        isshow: false,
                    };
                }
            }
            if (j === 12) {
                obj.v.v = testdata[i].c单位;
                obj.v.m = testdata[i].c单位;
                if ('oc单位' in testdata[i]) {
                    obj.v.ps = {
                        left: 0,
                        top: 0,
                        width: 10,
                        height: 20,
                        value: '修改前：' + (testdata[i].oc单位 === null ? '' : testdata[i].oc单位 + ''),
                        isshow: false,
                    };
                }
            }
            if (j === 13) {
                obj.v.v = testdata[i].c重量or面积;
                obj.v.m = testdata[i].c重量or面积;
                // obj.v.ct.fa = '0.00'
                // obj.v.ct.t = 'n'
                if ('oc重量or面积' in testdata[i]) {
                    obj.v.ps = {
                        left: 0,
                        top: 0,
                        width: 10,
                        height: 20,
                        value: '修改前：' + (testdata[i].oc重量or面积 === null ? '' : testdata[i].oc重量or面积 + ''),
                        isshow: false,
                    };
                }
            }
            if (j === 14) {
                obj.v.v = testdata[i].c单价;
                obj.v.m = testdata[i].c单价;
                if ('oc单价' in testdata[i]) {
                    obj.v.ps = {
                        left: 0,
                        top: 0,
                        width: 10,
                        height: 20,
                        value: '修改前：' + (testdata[i].oc单价 === null ? '' : testdata[i].oc单价 + ''),
                        isshow: false,
                    };
                }
            }
            if (j === 15) {
                obj.v.v = testdata[i].c工件费;
                obj.v.m = testdata[i].c工件费;
                if ('oc工件费' in testdata[i]) {
                    obj.v.ps = {
                        left: 0,
                        top: 0,
                        width: 10,
                        height: 20,
                        value: '修改前：' + (testdata[i].oc工件费 === null ? '' : testdata[i].oc工件费 + ''),
                        isshow: false,
                    };
                }
            }
            if (j === 16) {
                obj.v.v = testdata[i].c金额;
                obj.v.m = testdata[i].c金额;
                // obj.v.ct.fa = '0.00'
                // obj.v.ct.t = 'n'
                if ('oc金额' in testdata[i]) {
                    obj.v.ps = {
                        left: 0,
                        top: 0,
                        width: 10,
                        height: 20,
                        value: '修改前：' + (testdata[i].oc金额 === null ? '' : testdata[i].oc金额 + ''),
                        isshow: false,
                    };
                }
            }
            if (j === 17) {
                obj.v.v = testdata[i].supplierName;
                obj.v.m = testdata[i].supplierName;
                if ('osupplierName' in testdata[i]) {
                    obj.v.ps = {
                        left: 0,
                        top: 0,
                        width: 10,
                        height: 20,
                        value: '修改前：' + (testdata[i].osupplierName === null ? '' : testdata[i].osupplierName + ''),
                        isshow: false,
                    };
                }
            }
            if (j === 18) {
                obj.v.v = testdata[i].c所属;
                obj.v.m = testdata[i].c所属;
                if ('oc所属' in testdata[i]) {
                    obj.v.ps = {
                        left: 0,
                        top: 0,
                        width: 10,
                        height: 20,
                        value: '修改前：' + (testdata[i].oc所属 === null ? '' : testdata[i].oc所属 + ''),
                        isshow: false,
                    };
                }
            }
            if (j === 19) {
                obj.v.v = testdata[i].c类别1;
                obj.v.m = testdata[i].c类别1;
                if ('oc类别1' in testdata[i]) {
                    obj.v.ps = {
                        left: 0,
                        top: 0,
                        width: 10,
                        height: 20,
                        value: '修改前：' + (testdata[i].oc类别1 === null ? '' : testdata[i].oc类别1 + ''),
                        isshow: false,
                    };
                }
            }
            if (j === 20) {
                obj.v.v = testdata[i].c类别2;
                obj.v.m = testdata[i].c类别2;
                if ('oc类别2' in testdata[i]) {
                    obj.v.ps = {
                        left: 0,
                        top: 0,
                        width: 10,
                        height: 20,
                        value: '修改前：' + (testdata[i].oc类别2 === null ? '' : testdata[i].oc类别2 + ''),
                        isshow: false,
                    };
                }
            }
            if (j === 21) {
                obj.v.v = testdata[i].c类别3;
                obj.v.m = testdata[i].c类别3;
                if ('oc类别3' in testdata[i]) {
                    obj.v.ps = {
                        left: 0,
                        top: 0,
                        width: 10,
                        height: 20,
                        value: '修改前：' + (testdata[i].oc类别3 === null ? '' : testdata[i].oc类别3 + ''),
                        isshow: false,
                    };
                }
            }
            if (j === 22) {
                obj.v.v = testdata[i].c模具类型;
                obj.v.m = testdata[i].c模具类型;
                if ('oc模具类型' in testdata[i]) {
                    obj.v.ps = {
                        left: 0,
                        top: 0,
                        width: 10,
                        height: 20,
                        value: '修改前：' + (testdata[i].oc模具类型 === null ? '' : testdata[i].oc模具类型 + ''),
                        isshow: false,
                    };
                }
            }
            if (j === 23) {
                obj.v.v = testdata[i].c客户名称;
                obj.v.m = testdata[i].c客户名称;
                if ('oc客户名称' in testdata[i]) {
                    obj.v.ps = {
                        left: 0,
                        top: 0,
                        width: 10,
                        height: 20,
                        value: '修改前：' + (testdata[i].oc客户名称 === null ? '' : testdata[i].oc客户名称 + ''),
                        isshow: false,
                    };
                }
            }
            if (j === 24) {
                obj.v.v = testdata[i].c产线;
                obj.v.m = testdata[i].c产线;
                if ('oc产线' in testdata[i]) {
                    obj.v.ps = {
                        left: 0,
                        top: 0,
                        width: 10,
                        height: 20,
                        value: '修改前：' + (testdata[i].oc产线 === null ? '' : testdata[i].oc产线 + ''),
                        isshow: false,
                    };
                }
            }
            if (j === 25) {
                obj.v.v = testdata[i].c受单日期 ? moment(testdata[i].c受单日期).format('YYYY-MM-DD') : '';
                obj.v.m = testdata[i].c受单日期 ? moment(testdata[i].c受单日期).format('YYYY-MM-DD') : '';
                obj.v.ct.fa = 'yyyy-MM-dd';
                obj.v.ct.t = 'd';
                if ('oc受单日期' in testdata[i]) {
                    obj.v.ps = {
                        left: 0,
                        top: 0,
                        width: 10,
                        height: 20,
                        value: '修改前：' + (testdata[i].oc受单日期 === null ? '' : moment(testdata[i].oc受单日期).format('YYYY-MM-DD') + ''),
                        isshow: false,
                    };
                }
            }
            if (j === 26) {
                obj.v.v = testdata[i].c要求到厂日期 ? moment(testdata[i].c要求到厂日期).format('YYYY-MM-DD') : '';
                obj.v.m = testdata[i].c要求到厂日期 ? moment(testdata[i].c要求到厂日期).format('YYYY-MM-DD') : '';
                obj.v.ct.fa = 'yyyy-MM-dd';
                obj.v.ct.t = 'd';
                if ('oc要求到厂日期' in testdata[i]) {
                    obj.v.ps = {
                        left: 0,
                        top: 0,
                        width: 10,
                        height: 20,
                        value: '修改前：' + (testdata[i].oc要求到厂日期 === null ? '' : moment(testdata[i].oc要求到厂日期).format('YYYY-MM-DD') + ''),
                        isshow: false,
                    };
                }
            }
            if (j === 27) {
                obj.v.v = testdata[i].c实际到厂日期 ? moment(testdata[i].c实际到厂日期).format('YYYY-MM-DD') : '';
                obj.v.m = testdata[i].c实际到厂日期 ? moment(testdata[i].c实际到厂日期).format('YYYY-MM-DD') : '';
                obj.v.ct.fa = 'yyyy-MM-dd';
                obj.v.ct.t = 'd';
                if ('oc实际到厂日期' in testdata[i]) {
                    obj.v.ps = {
                        left: 0,
                        top: 0,
                        width: 10,
                        height: 20,
                        value: '修改前：' + (testdata[i].oc实际到厂日期 === null ? '' : moment(testdata[i].oc实际到厂日期).format('YYYY-MM-DD') + ''),
                        isshow: false,
                    };
                }
            }
            if (j === 28) {
                obj.v.v = testdata[i].c延误天数;
                obj.v.m = testdata[i].c延误天数;
                obj.v.fc = testdata[i].c延误天数 > 0 ? '#ff1f1d' : '#438b3f';
                if ('oc延误天数' in testdata[i]) {
                    obj.v.ps = {
                        left: 0,
                        top: 0,
                        width: 10,
                        height: 20,
                        value: '修改前：' + (testdata[i].oc延误天数 === null ? '' : testdata[i].oc延误天数 + ''),
                        isshow: false,
                    };
                }
            }
            if (j === 29) {
                obj.v.v = testdata[i].cgbUser != null ? testdata[i].cgbUser.name : '';
                obj.v.m = testdata[i].cgbUser != null ? testdata[i].cgbUser.name : '';
                if ('oc采购负责人姓名' in testdata[i]) {
                    obj.v.ps = {
                        left: 0,
                        top: 0,
                        width: 10,
                        height: 20,
                        value: '修改前：' + (testdata[i].oc采购负责人姓名 === null ? '' : testdata[i].oc采购负责人姓名 + ''),
                        isshow: false,
                    };
                }
            }
            
            if (j === 30) {
                obj.v.v = testdata[i].bomImportRecordId;
                obj.v.m = testdata[i].bomImportRecordId;
            }
            if(j === 31){
                obj.v.v = testdata[i].isUpdate;
                obj.v.m = testdata[i].isUpdate;
            }
            arr.push(obj);
        }
    }
    return arr;
}

//格式化数据发送给后台
export function formaterSendData(params) {
    let arr = [];
    for (var i = 0; i < params.length / 32; i++) {
        let obj = {
            id: '',
            c项目名称: '',
            c订单号: '',
            c全名: '',
            c物料材质: '',
            c原料长度: '',
            c原料宽度: '',
            c原料高度: '',
            c原料直径: '',
            c图号: '',
            c数量: '',
            c单位: '',
            c重量or面积: '',
            c单价: '',
            c工件费: '',
            c金额: '',
            supplierName: '',
            c所属: '',
            c类别1: '',
            c类别2: '',
            c类别3: '',
            c模具类型: '',
            c客户名称: '',
            c产线: '',
            c受单日期: '',
            c要求到厂日期: '',
            c实际到厂日期: '',
            c延误天数: '',
            c采购负责人姓名: '',
            bOMImportRecordId: '',
            isUpdate:false,
        };
        for (var j = i * 32; j < (i + 1) * 32; j++) {
            if (i > 0) {
                // if(params[j].v.v === undefined){
                //     params[j].v.v = ''
                // }
                if (j === i * 32 + 2) {
                    obj.c项目名称 = params[j].v.v;
                }
                if (j === i * 32 + 3) {
                    obj.c订单号 = params[j].v.v;
                }
                if (j === i * 32 + 4) {
                    obj.c全名 = params[j].v.v;
                }
                if (j === i * 32 + 5) {
                    obj.c物料材质 = params[j].v.v;
                }
                if (j === i * 32 + 6) {
                    obj.c原料长度 = params[j].v.v;
                }
                if (j === i * 32 + 7) {
                    obj.c原料宽度 = params[j].v.v;
                }
                if (j === i * 32 + 8) {
                    obj.c原料高度 = params[j].v.v;
                }
                if (j === i * 32 + 9) {
                    obj.c原料直径 = params[j].v.v;
                }
                if (j === i * 32 + 10) {
                    obj.c图号 = params[j].v.v;
                }
                if (j === i * 32 + 11) {
                    obj.c数量 = params[j].v.v;
                }
                if (j === i * 32 + 12) {
                    obj.c单位 = params[j].v.v;
                }
                if (j === i * 32 + 13) {
                    obj.c重量or面积 = params[j].v.v;
                }
                if (j === i * 32 + 14) {
                    obj.c单价 = params[j].v.v;
                }
                if (j === i * 32 + 15) {
                    obj.c工件费 = params[j].v.v;
                }
                if (j === i * 32 + 16) {
                    obj.c金额 = params[j].v.v;
                }
                if (j === i * 32 + 17) {
                    obj.supplierName = params[j].v.v;
                }
                if (j === i * 32 + 18) {
                    obj.c所属 = params[j].v.v;
                }
                if (j === i * 32 + 19) {
                    obj.c类别1 = params[j].v.v;
                }
                if (j === i * 32 + 20) {
                    obj.c类别2 = params[j].v.v;
                }
                if (j === i * 32 + 21) {
                    obj.c类别3 = params[j].v.v;
                }
                if (j === i * 32 + 22) {
                    obj.c模具类型 = params[j].v.v;
                }
                if (j === i * 32 + 23) {
                    obj.c客户名称 = params[j].v.v;
                }
                if (j === i * 32 + 24) {
                    obj.c产线 = params[j].v.v;
                }
                if (j === i * 32 + 25) {
                    obj.c受单日期 = params[j].v.m;
                }
                if (j === i * 32 + 26) {
                    obj.c要求到厂日期 = params[j].v.m;
                }
                if (j === i * 32 + 27) {
                    obj.c实际到厂日期 = params[j].v.m;
                }
                if (j === i * 32 + 28) {
                    obj.c延误天数 = params[j].v.v;
                }
                if (j === i * 32 + 29) {
                    obj.c采购负责人姓名 = params[j].v.v;
                }
                if (j === i * 32 + 1) {
                    obj.id = params[j].v.m;
                }
                if (j === i * 32 + 30) {
                    obj.bOMImportRecordId = params[j].v.v;
                }
                if (j === i * 32 + 31) {
                    obj.isUpdate = params[j].v.v;
                }
            }
        }
        if (i > 0) {
            arr.push(obj);
        }
    }
    return arr;
}
